<template>
	<div class="container">
		頁面跳轉中，請稍候...
	</div>
</template>


<script>
	import {
		mixin
	} from '@/utils/mixin.js'
	export default {
		name: 'TW_MailTo',
		mixins: [mixin],
		data() {
			return {				
				language: 'tw', 	//语言版本
				orderNo: ''
			}
		},
		mounted() {
		},
		created() {
			this.orderNo = this.$route.query.OrderNo
			
			if(this.isMobile())
			{
				//手机
				window.location.href = 'http://m.hawaiiglobalholiday.com/pages/' + this.language + '/user/order_detail?OrderNo=' + this.orderNo
			}
			else
			{
				//电脑
				window.location.href = '/' + this.language + '/user/order_detail?OrderNo=' + this.orderNo
			}
		},
		methods: {
		},
	}
</script>

<style lang="less" scoped>
	@import url("../../assets/css/global.css");
	body {
		font-size: 13px;
	}
	.container {		
		width: 100vw;
		height: 100vh;
		text-align: center;
		line-height: 100vh;
	}
</style>